import { render, staticRenderFns } from "./EmbedCode.vue?vue&type=template&id=1baa6ac4&"
import script from "./EmbedCode.vue?vue&type=script&lang=js&"
export * from "./EmbedCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports